/* eslint-disable camelcase */
import { send, INTERACTION_TYPES } from '../javascripts/apopheniaLogger';

export default () => {
  document.addEventListener('feedback:interaction', (e) => {
    const data = e.detail;
    const instance = data.instance;

    send({
      value: data.value,
      options: data.options.map((o) => o.value),
      element_text: instance.querySelector('[slot="cta"]').innerText,
      screen_id: data.screenId,
      section_id: data.sectionId,
      element_id: data.elementId,
      referral_key: window.ELP_RFID,
      version: parseInt(data.version, 10),
      interaction_type: INTERACTION_TYPES.CLICKED
    });
  });
};
